import { Controller } from "@hotwired/stimulus"

// Keeps a waiting-room counter honest between Turbo Stream updates. The
// server renders the correct value; this only advances it on the minute so a
// staff member watching the board sees the number climb.
export default class extends Controller {
  static values = { startedAt: String, ceiling: Number, warnAt: Number }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 30000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const minutes = Math.floor((Date.now() - new Date(this.startedAtValue)) / 60000)
    this.element.textContent = `${minutes} min`

    const calm = ["bg-gray-100", "text-gray-700", "dark:bg-gray-700", "dark:text-gray-300"]
    const warn = ["bg-amber-100", "text-amber-900", "dark:bg-amber-900/30", "dark:text-amber-300"]
    const alert = ["bg-red-100", "text-red-800", "dark:bg-red-900/30", "dark:text-red-300"]

    this.element.classList.remove(...calm, ...warn, ...alert)

    if (minutes >= this.ceilingValue) {
      this.element.classList.add(...alert)
    } else if (minutes >= this.warnAtValue) {
      this.element.classList.add(...warn)
    } else {
      this.element.classList.add(...calm)
    }
  }
}
